import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { hideAlert } from 'actions/notifications.js';
import moment from 'moment';
import NotificationDropdown from './NotificationDropdown.jsx';
import {
  AnimationContainer,
  Container,
  Close,
  IconContainer,
  Icon,
  TextContainer,
  Title,
  NotificationText,
  DateText,
} from './styled';

const constructNotificationTitle = ({ alert_type, content = '' }) => {
  switch (alert_type) {
    case 'report':
      return `Report ready to view`;
    case 'insight':
      return content;
    case 'action_required':
      return 'New Action Required';
    default:
      break;
  }
};

const constructNotificationText = ({ content, alert_type }) => {
  switch (alert_type) {
    case 'report':
      return `Report "${content.report_name}" is ready to view.`;
    default:
      return 'Lorem ipsum solor sit amet, consect etur';
  }
};

const constructRelativePath = (url) => {
  const startIndex = url.indexOf('/blueprint');
  return url.slice(startIndex);
};

const constructTimestamp = ({ created_at }) => moment().to(moment.utc(created_at));

class Notification extends React.Component {
  componentDidMount() {
    if (this.props.close) {
      this.selfDestruct = setInterval(this.props.close(), 7000);
    }
  }

  componentWillUnmount() {
    if (this.selfDestruct) {
      clearInterval(this.selfDestruct);
    }
  }

  markAsSeen() {
    const { close, hideNotification, data: { public_id }, closeMenu } = this.props;
    close && close(public_id);
    closeMenu && closeMenu();
    hideNotification(public_id);
  }

  render() {
    const { data, close, showOptions, style } = this.props;
    return (<AnimationContainer style={style} allowOverflow={!close && showOptions}>
      <Container allowOverflow={!close && showOptions}>
        {close && <Close onClick={() => this.markAsSeen()}>×</Close>}
        <IconContainer>
          <Icon type={data.alert_type} />
        </IconContainer>
        <Link onClick={() => this.markAsSeen()} to={constructRelativePath(data.link)}>
          <TextContainer showOptions={showOptions} >
            <Title>{constructNotificationTitle(data)}</Title>
            <NotificationText>{constructNotificationText(data)}</NotificationText>
            <DateText marginTop="5px" seen={data.seen_at}>{constructTimestamp(data)}</DateText>
          </TextContainer>
        </Link>
        {showOptions && <NotificationDropdown alertId={data.public_id} />}
      </Container>
    </AnimationContainer>);
  }
}

const mapDispatchToProps = (dispatch) => ({
  hideNotification: (alertId) => dispatch(hideAlert({ alertId })),
});

export default connect(null, mapDispatchToProps, null, { forwardRef: true })(Notification);
